import axios from 'axios'
import { EXCLUIR_TRECHO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirTrecho (idTrecho, idEmpresa) {
  const url = `${URL}/trecho/${idTrecho}/empresa/${idEmpresa}/excluir`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_TRECHO,
        payload: response

      })
  );
}
